import { abrirGovbr, deslogarUsuario, acessoNegadoProcurador } from '../../login/actions';
import { buscarServicoPorSigla } from "apps/requerimentos/selecaoServicos/actions";
import { closeMessage, iniciarValidacao } from "apps/requerimentos/iniciar/actions";
import { consultarListaDeBeneficiosParaProrrogacaoFim, iniciarValidacaoProrrogacao } from "apps/requerimentos/prorrogar/actions";
import { convertToItemMenu } from "painel/component/newdashboard/servicos";
import { gravaBreadcrumb, requestLaunchExternalLink, requestLaunchSagService, servicoSelecionado, setTituloPagina, setMsgAcessoProcurador } from '../../painel/actions'; 
import { LISTA_SIGLAS_SERVICOS_LEGADOS, SIGLA_SERVICO_CONCESSAO_BENEFICIO_INCAPACIDADE, SIGLA_SERVICO_PRORROGACAO_BENEFICIO_INCAPACIDADE } from "apps/requerimentos/selecaoServicos/siglaServico";
import { oldServicesUrl, platform } from "platformImpl";
import { redirecionarServicosLegadosBI } from "apps/requerimentos/consultar/actions";
import { releaseBackground } from "../../painel/helper";
import { setPaginaServicoNaoHabilitado } from "apps/servicoNaoHabilitado/actions";
import { setPreviewPage, setRequerimentoTO } from "apps/requerimentos/onboarding/actions";
import { TK_TIPOS_ACAO_SELECAO_SERVICO } from "./tracker";
import history from '../../history';
import store from '../../store';
import verificarAcessoProcurador, { buscarPermissaoProcurador, isProcurador, logAgentAttempt } from "procurador";
import ProcuradorAcessoNegado from "painel/component/newdashboard/ProcuradorAcessoNegado";
import { limparFeedBack } from 'painel/component/feedback/actions';

/**
 * Busca recursiva de um serviço pela sua sigla usando o array dos itens de menu
 * @param {Array} itens Array de items do menu (state.app.menuItems)
 * @param {string} sigla Sigla do serviço a ser encontrado
 * @returns {Object} Serviço correspondente
 */
export const encontrarServicoPorSigla = (itens, sigla) => {
  for (const item of itens) {
    if (item.sigla === sigla) return item;
    if (item.items) {
      const found = encontrarServicoPorSigla(item.items, sigla);
      if (found) return found;
    }
  }
  return null;
};

export const isClickableItem = (service) => {
    return service && Boolean(service.miService || service.sagService || service.menuPage || service.oldVersionService || service.externalLink || service.nbLink || service.appFunction);
}

const isItemMenu = (service) => {
    return isClickableItem(service);
}

const addComplementoURLOrigem = (telaOrigem) => {
    if (telaOrigem === "MENU") {
        return `?tk-categoria=${TK_TIPOS_ACAO_SELECAO_SERVICO.MENU}`
    } else {
        return ""
    }
}

export const navigateWithHref = (url, telaOrigem = "") => {
    
    if (url != null) {
        if (url.includes("v35/index.html")) {
            if(telaOrigem !== "MENU"){
                store.dispatch(gravaBreadcrumb());
            }
            setTimeout(() => {
                window.location.href = url;
            }, 500);
        }else{
            window.location.href = url;
        }
    }
}

export const launch = (serviceParam, origemClick = "") => {    

    const verificaPermissoes = (permissoes) => {
        return (permissoes != null)
    }
    
    const logarAcessoProcurador = (permissoes) => {
        return permissoes[0].log;
    }

    releaseBackground();
    const usuario = store.getState().session.usuario;

    let service = isItemMenu(serviceParam) ? {...serviceParam} : convertToItemMenu(serviceParam);
    if (!service) return;
    
    const dadosDivergentes = store?.getState()?.session?.dadosDivergentes;
    if (dadosDivergentes && dadosDivergentes.length > 0 
            && !service.hasOwnProperty("externalLink") && origemClick !== "DADOS_DIVERGENTES") {
        return history.push('/dados-divergentes')
    }

    if (platform.isWeb && service.manutencaoWeb) {
        store.dispatch(servicoSelecionado(service));
        return history.push('/servico-manutencao' + addComplementoURLOrigem(origemClick));
    }

    if (platform.isCordova && service.manutencaoMobile) {
        store.dispatch(servicoSelecionado(service));
        return history.push('/servico-manutencao' + addComplementoURLOrigem(origemClick));
    }

    if (service.hasOwnProperty('miService') && service.isHabilitadoPedirInss === false) {
        store.dispatch(setPaginaServicoNaoHabilitado({ titulo: service.titulo, descricao: service.descricao }));
        return history.push('/servico-nao-habilitado');
    }

    if (service.hasOwnProperty('miService')) {        
        if (service.path) {
            if (service.hasOwnProperty('oldVersionService')) {
                let permissoes = verificarAcessoProcurador(service.rootPath);                            
                if (permissoes && permissoes.length == 0) {                           
                    const permissao = buscarPermissaoProcurador(service.rootPath)                                                    
                    let msg = (permissao ? permissao.msg : '');
                    store.dispatch(setTituloPagina(service.oldVersionService))
                    store.dispatch(setMsgAcessoProcurador(msg))
                    return history.push('/acesso-negado-proc' + addComplementoURLOrigem(origemClick));                    
                }else{
                    if (verificaPermissoes(permissoes)){
                        if (logarAcessoProcurador(permissoes)){ 
                          logAgentAttempt(permissoes[0].perfil ? permissoes[0].perfil[0] : 1, permissoes[0].title);//passa 1 so pra evitar nullPointer
                        }
                    }
                }
                localStorage.setItem('oldVersionService', true)
                navigateWithHref(service.path)
            } else {
                store.dispatch(setTituloPagina(service.miService))                
                history.push(service.path + addComplementoURLOrigem(origemClick));
            }
        }

    } else if (service.hasOwnProperty('sagService')) {       
                
        if (!service.sigla) return;

        //verificar se a funcionalidade chamada foi Atualizar Dados no INSS
        //se for procurador, não permitir esse acesso        
        if (service.sigla === 'ATUDIV'){
            if (isProcurador(usuario)){
                store.dispatch(acessoNegadoProcurador());
                return;               
            }
        }
        let permissoes = verificarAcessoProcurador(service.rootPath);                            
        if (permissoes && permissoes.length == 0) {                           
            const permissao = buscarPermissaoProcurador(service.rootPath)                                                    
            let msg = (permissao ? permissao.msg : '');
            store.dispatch(setTituloPagina(service.sagService))
            store.dispatch(setMsgAcessoProcurador(msg))
            return history.push('/acesso-negado-proc' + addComplementoURLOrigem(origemClick));            
        }else{
            if (verificaPermissoes(permissoes)){
                if (logarAcessoProcurador(permissoes)){ 
                  logAgentAttempt(permissoes[0].perfil ? permissoes[0].perfil[0] : 1, permissoes[0].title);//passa 1 so pra evitar nullPointer
                }
            }
        }

        launchSagService(service, origemClick);

        return;

    } else if (service.hasOwnProperty('pagePath')) {
        if (service.pagePath) {
            history.push('/grupo/' + service.pagePath + addComplementoURLOrigem(origemClick))
        }

    } else if (service.hasOwnProperty('oldVersionService')) {                
                
        let permissoes = verificarAcessoProcurador(service.rootPath);                            
        if (permissoes && permissoes.length == 0) {                           
            const permissao = buscarPermissaoProcurador(service.rootPath)                                                                
            let msg = (permissao ? permissao.msg : '');            
            store.dispatch(setTituloPagina(service.oldVersionService))
            store.dispatch(setMsgAcessoProcurador(msg))
            return history.push('/acesso-negado-proc' + addComplementoURLOrigem(origemClick));
            
        } else {
            if (verificaPermissoes(permissoes)){
                if (logarAcessoProcurador(permissoes)){ 
                  logAgentAttempt(permissoes[0].perfil ? permissoes[0].perfil[0] : 1, permissoes[0].title);//passa 1 so pra evitar nullPointer
                }
            }
        } 
        if (service.rootPath) {            
            navigateWithHref(oldServicesUrl() + service.rootPath)
        }

    } else if (service.hasOwnProperty('externalLink')) {        
                
        if (service.url) {
            store.dispatch(requestLaunchExternalLink(service.url))
        }
    } else if (service.hasOwnProperty('nbLink')) {
        if (service.nb) {
            history.push('/meus-beneficios/' + service.nb + addComplementoURLOrigem(origemClick))
        }
    } else if (service.hasOwnProperty('appFunction')) {
        if (service.action) {
            if (service.action === "logout") {
                store.dispatch(deslogarUsuario());
            } else {
                eval(service.action);
            }
        }
    }

    if (service.forceLogin) {
        abrirGovbr();
    }
};

export const getServiceName = (service) => {
    if (!service) return "";

    if (service.hasOwnProperty('tituloCurto') && service.tituloCurto) {
        return service.tituloCurto;
    }
    if (service.hasOwnProperty('titulo') && service.titulo) {
        return service.titulo;
    }
    if (service.hasOwnProperty('miService')) {
        return service.miService;

    } else if (service.hasOwnProperty('sagService')) {
        return service.sagService;

    } else if (service.hasOwnProperty('menuPage')) {
        return service.menuPage;

    } else if (service.hasOwnProperty('oldVersionService')) {
        return service.oldVersionService;

    } else if (service.hasOwnProperty('externalLink')) {
        return service.externalLink;

    } else if (service.hasOwnProperty('nbLink')) {
        return service.nbLink;

    } else if (service.hasOwnProperty('appFunction')) {
        return service.appFunction;
    }
}

export const getServiceIconClass = (service) => {
    if (!service) return "";

    if (service.icon) {
        return service.icon;
    } else {

        if (service.hasOwnProperty('miService')) {
            return "fas fa-user";

        } else if (service.hasOwnProperty('sagService')) {
            return "fas fa-user";

        } else if (service.hasOwnProperty('pagePath')) {
            return "fas fa-bars";

        } else if (service.hasOwnProperty('oldVersionService')) {
            return "fas fa-user";

        } else if (service.hasOwnProperty('externalLink')) {
            return "fas fa-link";
        } else if (service.hasOwnProperty('nbLink')) {
            return "fas fa-user";
        } else if (service.hasOwnProperty('appFunction')) {
            return "fas fa-mobile-alt";
        }
    }
};

export const launchSagService = (service, telaOrigem) => {

    if (LISTA_SIGLAS_SERVICOS_LEGADOS.includes(service.sigla)) {
        redirecionarServicosLegadosBI(service, telaOrigem);
        return;
    }
    
    store.dispatch(setPreviewPage(history.location.pathname));

    if (service.sigla === SIGLA_SERVICO_CONCESSAO_BENEFICIO_INCAPACIDADE) {
        store.dispatch(iniciarValidacao());

        buscarServicoPorSigla(SIGLA_SERVICO_CONCESSAO_BENEFICIO_INCAPACIDADE)
            .then((res) => {
                store.dispatch(setRequerimentoTO('requerimentoTO.servicoSelecionado', res.data));
                history.push("/requerimentos/iniciar/informativo");
                store.dispatch(closeMessage());
            })
            .catch((err) => {
                store.dispatch(setTituloPagina(getServiceName(service)))
                history.push('/tela-erro-beneficio-incapacidade' + addComplementoURLOrigem(telaOrigem));
                store.dispatch(closeMessage());
            })

        return;
    }

    if (service.sigla === SIGLA_SERVICO_PRORROGACAO_BENEFICIO_INCAPACIDADE) {
        store.dispatch(iniciarValidacao());
        store.dispatch(iniciarValidacaoProrrogacao());

        buscarServicoPorSigla(SIGLA_SERVICO_PRORROGACAO_BENEFICIO_INCAPACIDADE)
            .then((res) => {
                store.dispatch(setRequerimentoTO('requerimentoTO.servicoSelecionado', res.data));
                history.push("/requerimentos/iniciar/informativo");
                store.dispatch(closeMessage());
                store.dispatch(consultarListaDeBeneficiosParaProrrogacaoFim())
            })
            .catch((err) => {
                history.push('/tela-erro-beneficio-incapacidade' + addComplementoURLOrigem(telaOrigem));
                store.dispatch(closeMessage());
                store.dispatch(consultarListaDeBeneficiosParaProrrogacaoFim());
            })

        return;
    }

    store.dispatch(requestLaunchSagService(service, telaOrigem));
    history.replace("/carregar-requerimento-sag");

}

export const getTkItem = (item, tkCategoria) => {
    if(tkCategoria){
      if(isClickableItem(item) || item.rota){
        let field = item.pagePath ? "pagePath" : item.path ? "path" : "rota";
        if(field){
          return {
            ...item, [field]: `${item[field]}?tk-categoria=${tkCategoria}`
          }
        }
      }
    }
    return item;
  }